@if (processedData$ | async; as processedData) {
    <div class="comparison-chart">
        <highcharts-chart [options]="processedData.chartConfig" />
    </div>
    @if (processedData.differencialData.differencialSettings; as differencialSettings) {
        <div class="comparison-icon">
            <ui-icon size="huge" [color]="differencialSettings.color" [name]="differencialSettings.icon" />
            <div class="comparison-text" [coloredTextColor]="differencialSettings.color">
                {{
                    differencialSettings.text
                        | customTranslate
                            : {
                                  absoluteGap: processedData.differencialData.absoluteGap,
                                  percentGap: processedData.differencialData.percentGap,
                                  reversedPercentGap: processedData.differencialData.reversedPercentGap
                              }
                }}
            </div>
        </div>
    }
}
